const comments = [
  {
    text: "A particularly good feature is the 'publish' via email/sms that you can send out periodically over the voting period. It certainly helped boost our response - more than 50% voted, which was excellent. ",
    author: "Evandy Hostel",
    address: "University of Ghana"
  },
  {
    text: "Polytick's security features made it easy for us to run an election while maintaining the secrecy of each voter's vote. We had confidence the results accurately reflected the wishes of our voters.",
    author: "Mawuko Tettey",
    address: "IAESTE (University of Ghana)"
  },
  {
    text: "As a first-time user, I cannot convey how fantastic this application was. I appreciate how user-friendly it is and how it ensured a fair SRC election.",
    author: "Patrick Badu",
    address: "Accra Technical University"
  },
  {
    text: "We use Polyticks to elect our JCR representative body. The fact that Polyticks is a trusted third party gives us confidence that no one can retrieve or manipulate the votes.",
    author: "Pentagon Hostel",
    address: "University of Ghana"
  },
];

export default comments;
